import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
//////////////////////////////////////////////////////////
import i18n from '@/i18n';
import {
	Button,
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from '@/app/shared/components';

import { CollectionsService } from '@/core/services';

const data = [
	{
		id: 1,
		title: i18n.t('onboardingCollections.step1.title'),
		description: i18n.t('onboardingCollections.step1.description'),
		img: process.env.VITE_ONBOARDING_COLLECTIONS_FIRST_IMAGE,
	},
	{
		id: 2,

		title: i18n.t('onboardingCollections.step2.title'),
		description: i18n.t('onboardingCollections.step2.description'),
		img: process.env.VITE_ONBOARDING_COLLECTIONS_SECOND_IMAGE,
	},
	{
		id: 3,

		title: i18n.t('onboardingCollections.step3.title'),
		description: i18n.t('onboardingCollections.step3.description'),
		img: process.env.VITE_ONBOARDING_COLLECTIONS_THIRD_IMAGE,
	},
	{
		id: 4,

		title: i18n.t('onboardingCollections.step4.title'),
		description: i18n.t('onboardingCollections.step4.description'),
		img: process.env.VITE_ONBOARDING_COLLECTIONS_FOURTH_IMAGE,
	},
];

interface OnboardingProps {
	action: Dispatch<SetStateAction<boolean>>;
}
export const OnboardingCollections: React.FC<OnboardingProps> = ({
	action,
}) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region States
	**********************/

	const handleConfirmOnboardingCollections = async () => {
		try {
			await CollectionsService.hideOnboardingCollections();

			action(false);
		} catch (error) {
			console.error(error);
		}
	};

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col gap-2">
			<Carousel>
				<CarouselContent>
					{data.map((item, index) => {
						return (
							<CarouselItem key={index}>
								<div className="flex items-center flex-col min-h-svh justify-center px-12 py-6 text-center gap-4">
									<div>
										<h1 className="text-2xl font-bold mb-2 leading-tight">
											{item.title}
										</h1>
										<p className="text-sm">
											{item.description}
										</p>
									</div>
									<img
										className="Onboarding max-w-[80%] mx-auto"
										src={item.img}
										alt={item.title}
									/>

									<div className="w-full">
										{item.id === 4 && (
											<Button
												onClick={() => {
													handleConfirmOnboardingCollections();
												}}
												variant={'secondary'}
												className="px-12 text-sm rounded-lg w-full"
											>
												{/* TODO
													Cambiar texto de boton a "Entendido", con algun emoticono tipo "pulgar hacia arriba o el que te parezca bien" 
												*/}
												{t('general.play')}
											</Button>
										)}
									</div>
								</div>
							</CarouselItem>
						);
					})}
				</CarouselContent>
				<CarouselPrevious
					variant={'arrow'}
					className="left-0 z-20 top-2/4 ml-4 hover:bg-transparent"
				/>
				<CarouselNext
					variant={'arrow'}
					className="right-0 z-20 top-2/4 mr-4 hover:bg-transparent"
				/>
			</Carousel>
		</div>
	);
};
